export enum FolderActionType {
    AddComment = 1,
    AddFile = 2,
    SendEmail = 3,
    Delete = 4,
    SetInStandByState = 5,
    RemoveFromStandByState = 6,
    AddReminder = 7,
    ArchiveFolder = 8,
    SetInWaitingArchivingState = 9,
    RemoveFromWaitingArchivingState = 10,
    DisplayDraftEmails = 11,
    SendSms = 12,
    FollowFolder = 13,
    StopFollowFolder = 14,
}
